export default __webpack_public_path__ + "static/media/stats_uv.f6289825.svg";